function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import { useEffect, useState } from 'react';
export var useEventQueue = function useEventQueue(props) {
  var interactionListSchema = props.interactionListSchema;
  // 维护事件队列，控制绑定事件
  var _useState = useState(interactionListSchema),
    _useState2 = _slicedToArray(_useState, 2),
    eventQueue = _useState2[0],
    setEventQueue = _useState2[1];
  useEffect(function () {
    if (JSON.stringify(interactionListSchema) !== JSON.stringify(eventQueue)) setEventQueue(interactionListSchema);
  }, [interactionListSchema]);

  // 移除事件
  var removeEvent = function removeEvent(key) {
    if (key) return setEventQueue(function (list) {
      return list.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.key) !== key;
      });
    });
    setEventQueue(function (list) {
      return list.filter(function (item, index) {
        return index !== 0;
      });
    });
  };
  // 初始化事件
  var initEvent = function initEvent() {
    setEventQueue(interactionListSchema);
  };
  return {
    eventQueue: eventQueue,
    removeEvent: removeEvent,
    initEvent: initEvent,
    setEventQueue: setEventQueue
  };
};